/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Share_ColumnInputs */

const en_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share of calls`)
};

const zh_hans1_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调用占比`)
};

const pt_br2_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcela das chamadas`)
};

const es_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcentaje de llamadas`)
};

const fr_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Part des appels`)
};

const de_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteil der Aufrufe`)
};

const ru_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доля вызовов`)
};

const it_endpoint_share_column = /** @type {(inputs: Endpoint_Share_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota di chiamate`)
};

/**
* | output |
* | --- |
* | "Share of calls" |
*
* @param {Endpoint_Share_ColumnInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_share_column = /** @type {((inputs?: Endpoint_Share_ColumnInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Share_ColumnInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_share_column(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_share_column(inputs)
	if (locale === "es") return es_endpoint_share_column(inputs)
	if (locale === "fr") return fr_endpoint_share_column(inputs)
	if (locale === "de") return de_endpoint_share_column(inputs)
	if (locale === "ru") return ru_endpoint_share_column(inputs)
	if (locale === "it") return it_endpoint_share_column(inputs)
	return en_endpoint_share_column(inputs)
});